import RulesDataContext from "contexts/RulesContext";
import { isEmpty } from "lodash";
import React from "react";

//maintain rules via url
export function isUrlAllowed(url, redirectToErrorPage = false, rulesDetails = null) {
  var rules = rulesDetails || getRules();
  if (rules === null) {
    return false;
  }
  var decision = true;
  var urlParts = getUrlPartsArray(url);

  //check the specific rules  here
  //rules = testRules(rules);

  //admin part
  if (!rules?.employeeAuthorisation?.companyAdmin && ["admin"].countSameItems(urlParts) > 0) {
    decision = false;
  }

  if ((!rules.organisationSettings.isLicensed) && !rules?.employeeAuthorisation?.companyAdmin && ["dashboard"].countSameItems(urlParts) > 0) {
    decision = false;
  }
  
  // check if user is suspended
  if (rules?.employeeAuthorisation?.suspended) {
    decision = false;
  }

  if (rules.organisationSettings) {
    //job req
    if (!rules.organisationSettings.allowsJobRequisition && ["jobrequisition"].countSameItems(urlParts) > 0) {
      decision = false;
    }
    //add job if job req
    //job req
    if (rules.organisationSettings.allowsJobRequisition && ["jobs", "add"].countSameItems(urlParts) > 1) {
      decision = false;
    }

    //is Licensed
    //talent pool
    if (((rules.organisationSettings.isLicensed && !rules?.employeeAuthorisation?.talentpoolAccess) || !rules.organisationSettings.isLicensed) && !rules.organisationSettings.GSMOnly && ["talentpool"].countSameItems(urlParts) > 0) {
      decision = false;
    }

    //subsites
    if ((!rules.organisationSettings.isLicensed || rules.organisationSettings.GSMOnly) && ["admin", "subsites"].countSameItems(urlParts) > 1) {
      decision = false;
    }

    if (rules.organisationSettings.GSMOnly && ["admin", "applicationprocess"].countSameItems(urlParts) > 1) {
      decision = false;
    }


    //security and access
    if (!rules.organisationSettings.isLicensed && ["admin", "hierarchyroles", "hierarchies", "employmentagreement", "extrainformation", "tokens"].countSameItems(urlParts) > 1) {
      decision = false;
    }

    if (!rules.organisationSettings.isLicensed && !rules.organisationSettings.GSMOnly && ["admin", "maintainusers", "modules", "integrations"].countSameItems(urlParts) > 1) {
      decision = false;
    }

    //admin/questionnaires/organisation
    if ((!rules.organisationSettings.isLicensed || rules.organisationSettings.GSMOnly) && ["admin", "questionnaires", "organisation"].countSameItems(urlParts) > 2) {
      decision = false;
    }

    //compensationitems
    if (!rules.organisationSettings.allowsOnboarding && ["admin", "compensationitems"].countSameItems(urlParts) > 1) {
      decision = false;
    }

    //tags
    if (!rules.organisationSettings.isLicensed && !rules.organisationSettings.GSMOnly && ["admin", "tags"].countSameItems(urlParts) > 1) {
      decision = false;
    }

    //candidatelist
    if (!rules.organisationSettings.isLicensed && !rules.organisationSettings.GSMOnly && ["admin", "candidatelists"].countSameItems(urlParts) > 1) {
      decision = false;
    }

    //organisation report
    if (!rules.organisationSettings.isLicensed && ["admin", "reports"].countSameItems(urlParts) > 1) {
      decision = false;
    }

    //report
    if ((!rules.organisationSettings.isLicensed || rules.organisationSettings.GSMOnly) && ["admin", "reportusers"].countSameItems(urlParts) > 1) {
      decision = false;
    }

    //report access
    if ((["report"].countSameItems(urlParts) > 0 || ["reports"].countSameItems(urlParts) > 0) && (!rules.organisationSettings.isLicensed || !userAllowedToViewReports(rules.reportAccessList, rules)) && !isGSMAdmin(rulesDetails)) {
      decision = false;
    }

    // searchandmatch
    if (!rules.organisationSettings.allowsSearchAndMatch && !rules.organisationSettings.GSMOnly && ["searchandmatch"].countSameItems(urlParts) > 0) {
      decision = false;
    }

    // if (!rules.organisationSettings.GSMOnly && ["searchandmatch"].countSameItems(urlParts) > 0) {
    //   decision = false;
    // }
    //admin/questionnaires/confidential
    if ((!rules.organisationSettings.isLicensed || rules.organisationSettings.GSMOnly) && ["admin", "questionnaires", "confidential"].countSameItems(urlParts) > 2) {
      decision = false;
    }
    if (rules.organisationSettings.GSMOnly && ["admin", "externaljobboards"].countSameItems(urlParts) > 1) {
      decision = false;
    }

    if (rules.organisationSettings.GSMOnly && ["admin", "compensationitems"].countSameItems(urlParts) > 1) {
      decision = false;
    }


    if (rules.organisationSettings.GSMOnly && ["admin", "declinationreasons"].countSameItems(urlParts) > 1) {
      decision = false;
    }

    if (rules.organisationSettings.GSMOnly && ["admin", "documentcategories"].countSameItems(urlParts) > 1) {
      decision = false;
    }

    //admin/questionnaires/confidential
    if (!rules.organisationSettings.isLicensed && ["admin", "questionnaires", "confidential"].countSameItems(urlParts) > 2) {
      decision = false;
    }

    //disable marketplace for gsm only organisation
    if (rules.organisationSettings.GSMOnly && ["admin", "marketplace"].countSameItems(urlParts) > 1) {
      decision =false;
    }
  }

  //check the specific rules  here
  return handleAuthDecision(decision, redirectToErrorPage);
}

//maintain rules via ui sections and url
export function isUISectionAllowed(uiSections, url = null, rulesDetails = null) {
  //var urlParts = getUrlPartsArray(url);

  var rules = rulesDetails || getRules();
  if (rules === null) {
    return false;
  }
  if (!Array.isArray(uiSections) || uiSections.length < 1) {
    return true;
  }
  var decision = true;

  //check the specific rules  here
  //rules = testRules(rules);

  //job req on permission form
  if (!rules?.organisationSettings?.allowsJobRequisition && ["AdminRoleJobRequisition"].countSameItems(uiSections) > 0) {
    decision = false;
  }

  //if jobReq allowed copy job not allowed
  // if (!rules.organisationSettings.allowsJobRequisition && ["AdminCopyJob"].countSameItems(uiSections) > 0) {
  //   decision = false;
  // }

  //job on permission form
  if (!rules?.employeeAuthorisation?.companyAdmin && ["AdminRoleJob"].countSameItems(uiSections) > 0) {
    decision = false;
  }

  //permission schema definitions
  if (!rules.organisationSettings?.allowsOnboarding && ["onboarding-bucket", "approve-job-package"].countSameItems(uiSections) > 0) {
    decision = false;
  }

  //add job allowed if job req for company
  // if (rules.organisationSettings.allowsJobRequisition && ["AdminAddJob"].countSameItems(uiSections) > 0) {
  //   decision = false;
  // }

  //check the specific rules  here
  return decision;
}

export function isRowEditable(row) {
  return Object.prototype.hasOwnProperty.call(row, "editable") ? row.editable : true;
}

export function isTableActionAllowed(action, i, row, tableRowActions, rulesDetails = null) {
  var lc_action = action.toLowerCase();
  var viewActions = ["view", "copyurl", "viewjobreq", "applications"];
  if (lc_action === "changepanelmembers" && row.currentState === "active") {
    return true;
  } else if (lc_action === "changepanelmembers" && (row.currentState === "archived" || row.currentState === "draft")) {
    return false;
  }
  var isViewOrCopyUrl = viewActions.indexOf(lc_action) != -1 ? true : false;
  var isNotCopyAndEditable = isRowEditable(row) && lc_action != "copy" ? true : false;
  var isCopyAllowed = lc_action == "copy" && isRowEditable(row) && isUISectionAllowed(["AdminCopyJob"], null, rulesDetails) ? true : false;
  var tableRowsConditions = (!Object.prototype.hasOwnProperty.call(tableRowActions, "isShow" + action) || tableRowActions["isShow" + action](row)) && Object.prototype.hasOwnProperty.call(tableRowActions, "handle" + action) ? true : false;

  return (isViewOrCopyUrl || isNotCopyAndEditable || isCopyAllowed) && tableRowsConditions;
}

export function handleAuthDecision(decision, redirectToErrorPage = true) {
  if (!decision && redirectToErrorPage) {
    window.location.href = "/403?detail=&message=Access+denied!+You+do+not+have+access+to+this+page.";
  }
  return decision;
}

export function getRules() {
  const rulesDetails = React.useContext(RulesDataContext);
  return isEmpty(rulesDetails) ? null : rulesDetails;
}

//moved from redux / actions / auth
export function currentUserIsCompanyAdmin(rulesDetails = null) {
  return getCurrentEmployeeAuthorisation(rulesDetails)?.companyAdmin;
}

export function userIsAdminOrInRole(roleName, hierarchyId, rulesDetails = null) {
  let response = false;
  let employeeAuthorisation = getCurrentEmployeeAuthorisation(rulesDetails);
  if (employeeAuthorisation?.companyAdmin || employeeAuthorisation.payrollUser) {
    return true;
  } else {
    let filteredEmployeeGroup = employeeAuthorisation && Object.prototype.hasOwnProperty.call(employeeAuthorisation, "employeeGroups") ? employeeAuthorisation.employeeGroups.find((g) => g.id === hierarchyId) : null;
    response = findRoleInEmployeeGroup(filteredEmployeeGroup, roleName);
  }
  return response;
}

export function userIsAdminOrInRoleAllHierarchies(roleName, rulesDetails = null) {
  let response = false;

  if (currentUserIsCompanyAdmin(rulesDetails)) {
    return true;
  } else {
    let employeeAuthorisation = getCurrentEmployeeAuthorisation(rulesDetails);
    let employeeGroups = employeeAuthorisation && Object.prototype.hasOwnProperty.call(employeeAuthorisation, "employeeGroups") ? employeeAuthorisation.employeeGroups : null;
    if (employeeGroups && employeeGroups.length) {
      const result = employeeGroups.find((eg) =>
        eg.permissionGroups.some((pg) =>
          pg.roles.some((role) => role.name === roleName)
        )
      );
      response = result ? true : false;
    }
  }
  return response;
}

function findRoleInEmployeeGroup(employeeGroups, roleName) {
  if (employeeGroups && employeeGroups?.permissionGroups) {
    var role = employeeGroups.permissionGroups.find((permissionGroup) => 
    permissionGroup.roles.some((role) => role.name === roleName)
    );
    return role ? true : false;
  }
  return false;
}

function getParentStateName(fullStateName) {
  var parentRoleIndex = fullStateName.indexOf(".");
  if (parentRoleIndex !== -1) {
    fullStateName = fullStateName.substring(0, parentRoleIndex);
  }
  return fullStateName;
}

function userIsInReportAccessList(reportAccessList, rules = null) {
  let employeeAuthorisation = getCurrentEmployeeAuthorisation(rules);
  return employeeAuthorisation.companyAdmin || employeeAuthorisation.payrollUser || (reportAccessList && reportAccessList.includes(employeeAuthorisation.id));
}
//overwrite rules to test use case
// function testRules(rules){
//   rules.organisationSettings.isLicensed = true;
//   rules.organisationSettings.allowsOnboarding = false;
//   rules.employeeAuthorisation.companyAdmin = true;
//   rules.organisationSettings.allowsJobRequisition = false;
//    return rules;
// }

//hierarchyId needed

export function userAllowedToManageApplicationState(hierarchyId, applicationState, rulesDetails = null) {
  return userIsAdminOrInRole("manage-" + getParentStateName(applicationState) + "-bucket", hierarchyId, rulesDetails);
}

export function userAllowedToViewApplicationState(hierarchyId, applicationState, rulesDetails = null) {
  return userIsAdminOrInRole("view-" + getParentStateName(applicationState) + "-bucket", hierarchyId, rulesDetails);
}

export function userAllowedToSendCommsFor(hierarchyId, rulesDetails = null) {
  return userIsAdminOrInRole("communication", hierarchyId, rulesDetails);
}

export function userAllowedToMaintainExternalJobBoards(hierarchyId, rulesDetails = null) {
  return userIsAdminOrInRole("edit-job", hierarchyId, rulesDetails);
}

export function userAllowedToOfferApprovalFor(hierarchyId, rulesDetails = null) {
  return userIsAdminOrInRole("approve-job-package", hierarchyId, rulesDetails);
}

export function userAllowedToViewReports(reportAccessList, rules = null) {
  return userIsInReportAccessList(reportAccessList, rules);
}

export function getCurrentCompany() {
  var rules = getRules();
  return rules ? rules?.companyDetails : null;
}

export function isCompanyActivated() {
  var rules = getRules();
  return rules ? rules.organisationSettings.activated : false;
}

export function getCurrentCompanyId(rulesDetails = null) {
  var rules = rulesDetails || getRules();
  return rules ? rules?.companyDetails?.id : localStorage.getItem("company-id");
}

export function getCurrentEmployeeAuthorisation(rulesDetails = null) {
  var rules = rulesDetails || getRules();
  return rules ? rules?.employeeAuthorisation : null;
}

export function getCurrentEmployeeAuthorisationId(rulesDetails = null) {
  var rules = rulesDetails || getRules();
  return rules ? rules?.employeeAuthorisation.id : null;
}

const ERROR_CODES = [
  "400",
  "401",
  "402",
  "403",
  "404",
  "405",
  "406",
  "407",
  "408",
  "409",
  "410",
  "411",
  "412",
  "413",
  "414",
  "415",
  "416",
  "417",
  "418",
  "422",
  "423",
  "424",
  "425",
  "426",
  "449",
  "450",
  "500",
  "501",
  "502",
  "503",
  "504",
  "505",
  "506",
  "507",
  "509",
  "510",
];

export function isErrorPage(url) {
  if (url === "/no-organisation") {
    return true;
  }

  return url && ERROR_CODES.indexOf(url.replace("/", "")) !== -1 ? true : false;
}

export function isGSMOnlyOrg(inputRules = null) {
  let rules = inputRules ? inputRules : getRules();
  if (rules === null) {
    return false;
  }
  let decision = false;
  if (!rules?.employeeAuthorisation?.suspended && rules.organisationSettings && rules.organisationSettings.GSMOnly) {
    decision = true;
  }
  return decision;
}

export function isGSMAdmin(rulesDetails = null) {
  let rules = rulesDetails || getRules();
  return rules?.organisationSettings.GSMOnly && rules?.employeeAuthorisation?.companyAdmin;
}

export function isInvoiceOrg(rulesDetails = null) {
  let rules = rulesDetails || getRules();
  if (rules === null) {
    return false;
  }
  let decision = false;
  if (!rules?.employeeAuthorisation?.suspended && rules.paymentMethodType && rules.paymentMethodType == 1) {
    decision = true;
  }
  return decision;
}

export function getUrlPartsArray(url) {
  return url === null ? [""] : url.toLowerCase().indexOf("/") !== -1 ? url.split("/") : [String(url)];
}

Array.prototype.countSameItems = function (a) {
  return this.map((v) => v.toLowerCase()).filter((i) => {
    return a.map((v) => v.toLowerCase()).indexOf(i) !== -1;
  }).length;
};

export function getRulesDetails(companyDetails, organization, employeeAuthorisationData = null) {
  let rules = {};

  const organisationSettings = organization?.organisationSettings;
  const reportAccessList = organization?.reportAccess;
  const paymentMethodType = organization?.paymentMethodType;

  if (companyDetails && organization) {
    //auth
    if (typeof employeeAuthorisationData !== "undefined") {
      rules.employeeAuthorisation = employeeAuthorisationData;
    }

    //companyDetails
    if (typeof companyDetails !== "undefined") {
      rules.companyDetails = companyDetails;
    }

    //org settings
    if (typeof organisationSettings !== "undefined") {
      rules.organisationSettings = organisationSettings;
    }

    //report access user list
    if (typeof reportAccessList !== "undefined") {
      rules.reportAccessList = reportAccessList;
    }

    if (typeof paymentMethodType !== "undefined") {
      rules.paymentMethodType = paymentMethodType;
    }
    // amend rules to test use case
  }

  return isEmpty(rules) ? null : rules;
}

export const handleLogout = (keycloak, locationOrigin) => {
  localStorage.removeItem("checkSubscription");
  localStorage.removeItem("company-id");
  localStorage.removeItem("company-name");

  if (keycloak.authenticated && keycloak.idToken) {
    const logoutUrl = `${keycloak.authServerUrl}/realms/${keycloak.realm}/protocol/openid-connect/logout` +
                      `?id_token_hint=${keycloak.idToken}` +
                      `&post_logout_redirect_uri=${encodeURIComponent(locationOrigin)}`;
    
    window.location.href = logoutUrl;
  }
};